import React from 'react';
import styleConstants from 'src/styles/constants';
import LOGO_URL from './constants';

const ThinkificLogo = () => (
  <>
    <img alt="Thinkific logo" className="logo" src={LOGO_URL} />
    <style jsx>{`
      .logo {
        display: block;
        margin: ${styleConstants.spacing.six} auto;
        max-width: 180px;
      }
    `}</style>
  </>
);

export default ThinkificLogo;
